import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "members-list small-av"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_4 = {
  key: 1,
  href: "javascript:void(0)"
}
const _hoisted_5 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_8 = {
  key: 1,
  href: "javascript:void(0)"
}
const _hoisted_9 = {
  key: 2,
  href: "javascript:void(0)"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }),
  /*#__PURE__*/_createTextVNode(" No members Yet !")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.projectMembers && _ctx.projectMembers.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectMembers, (member, memberIndex) => {
            return (_openBlock(), _createBlock("li", {
              class: "member-img-cirlce",
              key: memberIndex
            }, [
              (member.full_name)
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    (member.role === 4)
                      ? (_openBlock(), _createBlock("a", _hoisted_3, [
                          (member.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: member.image,
                                alt: "",
                                title: `${member.full_name}(${member.email})/Sub Contractor`
                              }, null, 8, ["src", "title"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                title: `${member.full_name}(${member.email})/Sub Contractor`,
                                src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                alt: ""
                              }, null, 8, ["title", "src"]))
                        ]))
                      : (member.role === 1)
                        ? (_openBlock(), _createBlock("a", _hoisted_4, [
                            (member.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.image,
                                  alt: "",
                                  title: `${member.full_name}(${member.email})/Owner`
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  title: `${member.full_name}(${member.email})/Owner`,
                                  src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                  alt: ""
                                }, null, 8, ["title", "src"]))
                          ]))
                        : (_openBlock(), _createBlock("a", _hoisted_5, [
                            (member.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.image,
                                  alt: "",
                                  title: `${member.full_name}(${member.email})`
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  title: `${member.full_name}(${member.email})`,
                                  src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                  alt: ""
                                }, null, 8, ["title", "src"]))
                          ]))
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_6, [
                    (member.role === 4)
                      ? (_openBlock(), _createBlock("a", _hoisted_7, [
                          (member.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: member.image,
                                alt: "",
                                title: `(${member.email})/Sub Contractor`
                              }, null, 8, ["src", "title"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                title: `(${member.email})/Sub Contractor`,
                                src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                alt: ""
                              }, null, 8, ["title", "src"]))
                        ]))
                      : (member.role === 1)
                        ? (_openBlock(), _createBlock("a", _hoisted_8, [
                            (member.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.image,
                                  alt: "",
                                  title: `(${member.email})/Owner`
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  title: `(${member.email})/Owner`,
                                  src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                  alt: ""
                                }, null, 8, ["title", "src"]))
                          ]))
                        : (_openBlock(), _createBlock("a", _hoisted_9, [
                            (member.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.image,
                                  alt: "",
                                  title: `${member.email}`
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  title: `${member.email}`,
                                  src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
            ,
                                  alt: ""
                                }, null, 8, ["title", "src"]))
                          ]))
                  ])),
              _createVNode("div", {
                class: 
            member.status === 2
              ? 'member-status-wrap active accepted'
              : 'member-status-wrap accepted'
          
              }, [
                _hoisted_10
              ], 2),
              _createVNode("div", {
                class: 
            member.status === 1
              ? 'member-status-wrap active pending'
              : 'member-status-wrap pending'
          
              }, [
                _hoisted_11
              ], 2),
              _createVNode("div", {
                class: 
            member.status === 3
              ? 'member-status-wrap active declined'
              : 'member-status-wrap declined'
          
              }, [
                _hoisted_12
              ], 2)
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_13, [
        _hoisted_14
      ]))
}